import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { CrossSellConfig } from '@frontend/sports/common/client-config-data-access';
import { LiveCasinoCategoryModel, LiveCasinoGamesResponse } from '@frontend/sports/types/components/live-casino';
import { UserService } from '@frontend/sports/user/feature';
import { KycStatusService } from '@frontend/vanilla/shared/kyc';
import { Observable, map } from 'rxjs';

import { getKycStatus } from './cross-sell-utils';

@Injectable({ providedIn: 'root' })
export class CrossSellDataService {
    private crossSellConfig = inject(CrossSellConfig);
    private user = inject(UserService);
    private kycStatusService = inject(KycStatusService);
    private apiService = inject(ApiService);

    getLiveCasinoGames(): Observable<LiveCasinoCategoryModel[]> {
        if (this.user.isAuthenticated && this.crossSellConfig.isKYCCheckEnabled) {
            return this.getCasinoGames(this.kycStatusService.status()?.kycVerified);
        } else {
            return this.getCasinoGames();
        }
    }

    getCasinoGames(isKycVerified: boolean = false): Observable<LiveCasinoCategoryModel[]> {
        return this.apiService
            .get<LiveCasinoGamesResponse>('crossSell/getLiveCasinoGames', {
                kycStatus: getKycStatus(isKycVerified, this.user.isAuthenticated),
            })
            .pipe(
                map((r) => {
                    return r.data;
                }),
            );
    }
}
